import { HEADER_HEIGHT_CLASS } from '@/lib/shared/layout-constants'

/**
 * The panel's header row — tab strip (thread view) and list header alike.
 * Sized with the app header's own height class (border included, no
 * vertical padding) so the two bottom rules meet to the pixel across the
 * panel edge; a padding-derived height landed one pixel low. A leaf so a
 * server-rendered or loading shell can reserve the row without the
 * header's client controls.
 */
export const PANEL_HEADER_ROW_CLASS = `flex ${HEADER_HEIGHT_CLASS.height} shrink-0 items-center gap-1 border-border border-b px-2`
